/* eslint-disable eqeqeq */
import { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import ReactToPrint from 'react-to-print';
import { Button, Dropdown, Grid, Modal, Popup } from 'semantic-ui-react';

import {
  removeCachedActivitiesSteps,
  setCachedActivitiesSteps,
} from '../../../utils/cacheStore';

import {
  getReports,
  getReportViaEmail,
  putActivity,
  setUserOnboardingOption,
} from '../../../store/actions';

import emailSendIcon from '../../../assets/email-send.svg';

import {
  isParentProgramActivity,
  isSingleActivity,
} from '../../../utils/activity';

import { ACTIVITY_TAB_KEYS } from '../../../utils/constant';
import WHITELIST_USERS from '../../../utils/activity/specialPermissionUsers';
import CustomReportSlideout from '../../reportBuilder/CustomReportSlideout';
import { AuthService } from '../../../services';
import { INSTANCE_CONTACT_EMAIL } from '../../../utils/instanceConstant';
import { checkMemberPermission } from '../../../utils/activity/userPermission';
import { PERM_ACTIVITY_REPORT } from '../../../utils/constant';

import './activity.scss';

class ArchiveActivity extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async closeActivity() {
    try {
      const { modal } = this.state;
      const { currentActivity, closable, putActivity, user, t } = this.props;
      if (!currentActivity.isLinkedActivity && user.role === 'guest') {
        NotificationManager.warning(
          t('activity.permissions.guest_users_no_permission'),
          t('activity.takso_access')
        );
      } else {
        await putActivity('closeActivity', {
          statusId: closable === '2' || closable === 2 ? 3 : 2,
        });
      }
      if (modal) {
        this.toggle();
      }
    } catch (error) {
      // console.error('ActivitiesContainer -> closeActivity -> error', error);
    }
  }

  render() {
    const { modal } = this.state;
    const { closable, currentActivity, user, validationOutput, t } = this.props;
    const reportPermission = checkMemberPermission(
      user,
      currentActivity.members,
      PERM_ACTIVITY_REPORT
    );

    const isWhitelistOwner = WHITELIST_USERS.includes(user.email);

    return currentActivity.parentId && currentActivity.statusId === 3 ? null : (
      <Fragment>
        <Button
          loading={
            this.props.actPut.closeActivity
              ? this.props.actPut.closeActivity
              : false
          }
          //archive issues validations are not considered for re open
          disabled={
            (this.props.actPut.closeActivity ||
            (closable !== 3 && !validationOutput)
              ? true
              : false) ||
            (user.id != currentActivity.ownerId &&
              !reportPermission.write &&
              !isWhitelistOwner)
          }
          className={`close-button ${
            closable === 2 || closable === '2'
              ? validationOutput
                ? ' close-valid-btn'
                : ''
              : ' close-reopen-btn'
          }`}
          onClick={() =>
            currentActivity.parentId && currentActivity.statusId === 2
              ? this.toggle()
              : this.closeActivity()
          }
        >
          {closable === 2 || closable === '2'
            ? t('activity.archive.archive_activity')
            : t('activity.archive.reopen_activity')}
        </Button>
        <Modal size="tiny" open={modal} onClose={() => this.toggle()}>
          <Modal.Header>
            {t('activity.archive.complete_activity_record')}
          </Modal.Header>
          <Modal.Content>
            <p className="complete-act-info">
              {t('activity.archive.thank_you_for_completing_the_activity')}
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button className="modal-cancel" onClick={() => this.toggle()}>
              {t('actions.cancel')}
            </Button>
            <Button
              className="modal-proceed"
              onClick={() => this.closeActivity()}
              loading={
                this.props.actPut.closeActivity
                  ? this.props.actPut.closeActivity
                  : false
              }
              disabled={
                (this.props.actPut.closeActivity || !validationOutput
                  ? true
                  : false) ||
                (user.id != currentActivity.ownerId && !reportPermission.write)
              }
            >
              {t('actions.submit')}
            </Button>
          </Modal.Actions>
        </Modal>
      </Fragment>
    );
  }
}

class ActivitiesContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      infoSteps: false,
      modal: false,
      showCustomReport: false,
    };
  }

  async componentDidMount() {
    try {
      const { user } = this.props;
      if (!user.onboardingOption.activityFormTips) {
        this.setState({
          infoSteps: true,
        });
      }
    } catch (error) {
      removeCachedActivitiesSteps();
    }
  }

  getJoyRide(data) {
    if (data.type === 'tour:end') {
      this.setState(
        {
          infoSteps: false,
        },
        () => {
          setCachedActivitiesSteps(true);
        }
      );
    }
  }

  async repeatInfo() {
    try {
      this.setState({
        infoSteps: true,
      });
    } catch (error) {
      this.setState({
        infoSteps: false,
      });
    }
  }

  async showInfoModal() {
    this.setState({
      modal: true,
    });
  }

  async onExport() {
    const { downloadLink, getReports } = this.props;
    getReports(downloadLink, 'reportExport');
  }

  render() {
    const { modal, showCustomReport } = this.state;
    const {
      children,
      tabKey,
      previous,
      next,
      closable,
      currentActivity,
      currentTab,
      isEvaluationPageOpen = false,
      // reportAllImagesLoaded = true,
      getReports,
      getReportViaEmail,
      exportJsonLink,
      user,
      t,
    } = this.props;

    // Branch on the language-independent tab identity, never the translated
    // `title` (which broke i18n — e.g. the Report tab is "Rapport" in Dutch).
    const isReportTab = tabKey === ACTIVITY_TAB_KEYS.REPORT;
    const isErrorTab = tabKey === ACTIVITY_TAB_KEYS.ERROR;
    // Green Light is currently folded into the Evaluation tab, so nothing passes
    // this key today — retained so the Next-button rule keeps working if the
    // standalone Green Light tab is brought back.
    const isGreenLightTab = tabKey === ACTIVITY_TAB_KEYS.GREEN_LIGHT;

    const isSingle =
      currentActivity &&
      isSingleActivity(
        currentActivity.activityPlanTypeId,
        currentActivity.isLinkedActivity
      );

    return (
      <div className="full">
        {/* ref={el => (this.componentRef = el)} */}
        <div
          className={`act-content-layer ${
            currentActivity &&
            isParentProgramActivity(currentActivity.activityPlanTypeId)
              ? ' parent-act'
              : ''
          }`}
        >
          <div className="content-container">
            <Grid>
              {isReportTab ? (
                <Grid.Row
                  className="report-actions act-row no-print"
                  textAlign="right"
                >
                  <Grid.Column
                    // className="report-graph-col"
                    mobile={16}
                    tablet={16}
                    computer={16}
                    className="export-dropdown-btn"
                  >
                    {(AuthService.isSuperAdmin() ||
                      (AuthService.isOrgAdmin() &&
                        AuthService.isBetaTesterOrg())) && (
                      <Popup
                        content={
                          isSingle
                            ? t('activity.report.custom_reports.button_tooltip')
                            : t(
                                'activity.report.custom_reports.button_tooltip_not_available'
                              )
                        }
                        trigger={
                          <span className="d-inline-block">
                            <Button
                              size="small"
                              className="Secondary-Button"
                              disabled={!isSingle}
                              onClick={() =>
                                this.setState({ showCustomReport: true })
                              }
                            >
                              {t('report.builder.title')}
                            </Button>
                          </span>
                        }
                      />
                    )}

                    <Button
                      size="small"
                      className="Primary-Button export"
                      icon
                      labelPosition="left"
                    >
                      <Dropdown
                        text={t('actions.export')}
                        direction="left"
                        //inline
                        selectOnBlur={false}
                        icon="angle down"
                        //className="export-dropdown-btn"
                      >
                        <Dropdown.Menu>
                          <Dropdown.Item
                            className="dropdown-customItem"
                            onClick={() => {
                              getReportViaEmail(currentActivity.id).then(
                                (status) => {
                                  if (status) {
                                    this.showInfoModal();
                                  }
                                }
                              );
                            }}
                            children={
                              <label
                                style={{
                                  color: 'black',
                                }}
                              >
                                {t('actions.download_report')}
                              </label>
                            }
                          />

                          {/* hide for now */}
                          {/*** {user.role === 'admin' && (
                            <Dropdown.Item
                              className="dropdown-customItem"
                              onClick={() => {
                                getReports(
                                  exportJsonLink,
                                  'reportExport'
                                ).then((status) => {
                                  if (status) {
                                    this.showInfoModal();
                                  }
                                });
                              }}
                              children={
                                <label
                                  style={{
                                    color: 'black',
                                  }}
                                >
                                  {t('actions.download_json')}
                                </label>
                              }
                            />
                          )} ***/}

                          {/* <ReactToPrint
                            trigger={() => {
                              return (
                                <Dropdown.Item
                                  className="dropdown-customItem"
                                  onClick={() => window.print()}
                                >
                                  <label
                                    style={{
                                      color: 'black',
                                    }}
                                  >
                                    Print Report
                                  </label>
                                </Dropdown.Item>
                              );
                            }}
                            content={() => this.componentRef}
                          /> */}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              ) : null}
              <Grid.Row className="act-row">
                <Grid.Column
                  mobile={16}
                  tablet={16}
                  computer={16}
                  className="activity-sub-column"
                >
                  {children}
                </Grid.Column>
              </Grid.Row>

              {/* <div className="extra-height-container" /> */}
              {isEvaluationPageOpen ? null : (
                <>
                  {isErrorTab ? null : (
                    <Grid.Row className="act-footer" textAlign="right">
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <div className="footer-buttons">
                          {currentTab && currentTab !== 0 ? (
                            <Button
                              className="Secondary-Button"
                              onClick={() => previous()}
                            >
                              {t('common.previous')}
                            </Button>
                          ) : null}
                          {isReportTab ||
                          (isGreenLightTab &&
                            this.props.currentActivity.statusId !==
                              2) ? null : (
                            <Button
                              className="Primary-Button"
                              onClick={() => next()}
                            >
                              {t('common.next')}
                            </Button>
                          )}
                          {isReportTab && closable > 1 ? (
                            <ArchiveActivity {...this.props} />
                          ) : null}
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  )}
                </>
              )}
            </Grid>
          </div>
        </div>
        <Modal
          open={modal}
          onOpen={() => this.toggle()}
          size={'mini'} //  : 'small'
        >
          <Modal.Content>
            <div className="align-self-center justify-content-center text-center my-3">
              <img
                className="modal-report-error-img"
                alt="greenRight"
                src={emailSendIcon}
              />{' '}
            </div>

            <p className="text-center font-weight-bold my-3 modal-report-error-header">
              {t('activity.report.report_being_generated')}
            </p>
            <p className="text-center modal-report-error-paragraph">
              {t(
                'activity.report.your_report_is_being_compiled_and_will_be_sent_to_the_email_address_associated_with_this_account'
              )}
              <br />
              <br />
              {t(
                'activity.report.reports_with_multiple_graphs_may_take_a_few_minutes_to_generate'
              )}
              <br />
              <br />
              {t(
                'activity.report.if_you_have_not_received_your_report_in_15_minutes_please_contact'
              )}
              <br />
              <a
                className="contactUs"
                href={`mailto:${INSTANCE_CONTACT_EMAIL}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {INSTANCE_CONTACT_EMAIL}
              </a>
            </p>
          </Modal.Content>
          <Modal.Actions>
            <div className="align-self-center justify-content-center text-center">
              <Button
                className="modal-proceed px-5"
                content={t('actions.got_it')}
                onClick={() => this.setState({ modal: false })}
              />
            </div>
          </Modal.Actions>
        </Modal>
        {currentActivity && (
          <CustomReportSlideout
            open={showCustomReport}
            onClose={() => this.setState({ showCustomReport: false })}
            activityId={currentActivity.id}
            orgId={currentActivity.owner?.organisationId}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    user: state.authentication.user,
    currentActivity: state.activity.currentActivity,
    getReportsLoading: state.activity.getReportsLoading,
    actPut: state.activity.actPut,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      putActivity,
      getReports,
      getReportViaEmail,
      setUserOnboardingOption,
    },
    dispatch
  );
};

ActivitiesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ActivitiesContainer));

export { ActivitiesContainer };
